/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Logo } from 'assets/images';
import { fetchUserDevice } from 'store/modules/login/actions';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import isEmpty from 'lodash/isEmpty';
import utils from 'util/utils';

const tempPairingCode = () =>
  Array.from({ length: 6 }, () => Math.floor(Math.random() * 10)).join('');

const LogIn = () => {
  const user = useSelector((state) => state['features/login'].user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [pairingCode] = useState(() => tempPairingCode());

  async function checkAuth() {
    const userEmail = await utils.fetchUserEmail();
    if (userEmail && userEmail !== '' && !isEmpty(userEmail)) {
      navigate('/email-authentication', {
        state: { email: userEmail }
      });
    }

    const autoLogin = await utils.getAutoLogin();
    const rememberLogin = await utils.getRememberLogin();

    if ((autoLogin === 'true' || rememberLogin === 'true') && user) {
      dispatch(fetchUserDevice(user._id));
      navigate('/settings');
    }
  }
  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <Box className="outerContainer">
      <Box className="logo">
        <Logo color="#000" className={classes.logo} />
      </Box>
      <Box className={classes.header}>Welcome to Video Window!</Box>
      <Box
        className={classes.subHeader}
        style={{ padding: '8px 0px 16px 0px' }}>
        Please choose from the following
      </Box>
      <Box className="loginflex">
        <Box className="loginflex-item">
          <Link className="link" to="/activation-code">
            <Button className="outlineButton" variant="outlined">
              <Box className={classes.button}>
                This is a shared Video Window device
              </Box>
            </Button>
          </Link>
          <Box
            className={classes.hint}
            style={{ padding: '12px 0px 16px 0px' }}>
            For example an office common area device or kiosk device
          </Box>
        </Box>
        <Box className="loginflex-item">
          <Link className="link" to="/email-verification">
            <Button className="outlineButton" variant="outlined">
              <Box className={classes.button}>
                I am a person using Video Window on my own device
              </Box>
            </Button>
          </Link>
          <Box
            className={classes.hint}
            style={{ padding: '12px 0px 16px 0px' }}>
            For example a remote user on a tablet, phone or computer
          </Box>
        </Box>
      </Box>
      <Box className="flex">
        <Box className={classes.hint}>Don’t have an account?</Box> &nbsp;
        <Box
          className={classes.button}
          onClick={() => {
            window.location = 'https://videowindow.com/';
          }}>
          create
        </Box>
      </Box>
      <Box className={classes.hint} style={{ paddingTop: '16px' }}>
        v{process.env.REACT_APP_VERSION}
      </Box>
      <Box className={classes.hint} style={{ paddingTop: '40px' }}>
        Your pairing code is <strong>{pairingCode}</strong>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  logo: {
    width: '150px',
    height: '50px',
    '@media (max-width:600px)': {
      width: '150px',
      height: '50px'
    },
    '@media (min-width:600px) and (max-width:960px)': {
      width: '200px',
      height: '70px'
    },
    '@media (min-width:960px)': {
      width: '250px',
      height: '90px'
    }
  },
  header: {
    ...theme.typography.labelRegular,
    fontWeight: '100',
    color: theme.palette.text07Info
  },
  subHeader: {
    ...theme.typography.labelSmall,
    color: theme.palette.text05
  },
  button: {
    ...theme.typography.labelTiny,
    color: theme.palette.screen01,
    fontWeight: '600'
  },
  hint: {
    ...theme.typography.labelTiny,
    color: theme.palette.text05
  },
  footer: {
    ...theme.typography.labelSmall,
    color: theme.palette.text07Info
  },
  footerLink: {
    ...theme.typography.labelSmall,
    color: theme.palette.screen01
  }
}));

export default React.memo(withBoundary(LogIn));
